import useAppStore from "store/app"

const useLanguage = () => {
  const language = useAppStore((state) => state.meta.lang)
  const selectLanguage = useAppStore((state) => state.selectLanguage)
  const syncTranslations = useAppStore((state) => state.syncTranslations)

  const handleChange = (e) => {
    const currenLang = e.target.value

    selectLanguage(currenLang)
    localStorage.setItem("language", currenLang)
    syncTranslations()
  }

  const initLanguage = () => {
    syncTranslations()
  }

  const languages = [
    {
      code: "en",
      name: "English",
      flag: "🇺🇸",
    },
    {
      code: "ru",
      name: "Русский",
      flag: "🇷🇺",
    },
    {
      code: "es",
      name: "Español",
      flag: "🇪🇸",
    },
    // {
    //   code: "id",
    //   name: "Bahasa Indonesia",
    //   flag: "🇮🇩",
    // },
    {
      code: "pl",
      name: "Polski",
      flag: "🇵🇱",
    },
    {
      code: "vi",
      name: "Tiếng Việt",
      flag: "🇻🇳",
    },
    {
      code: "ml",
      name: "മലയാളം",
      flag: "🇮🇳",
    },
    {
      code: "ar",
      name: "العربية",
      flag: "🇸🇦",
    },
    {
      code: "bn",
      name: "বাংলা",
      flag: "🇧🇩",
    },
    {
      code: "hi",
      name: "हिन्दी",
      flag: "🇮🇳",
    },
    {
      code: "ta",
      name: "தமிழ்",
      flag: "🇮🇳",
    },
    {
      code: "ur",
      name: "اردو",
      flag: "🇵🇰",
    },
    {
      code: "tl",
      name: "Tagalog",
      flag: "🇵🇭",
    },
    {
      code: "zh",
      name: "中文",
      flag: "🇨🇳",
    },
    {
      code: "ms",
      name: "Bahasa Melayu",
      flag: "🇲🇾",
    },
  ]

  return {
    language,
    languages,
    handleChange,
    initLanguage,
  }
}

export default useLanguage
